var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolUsageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8892 9.53743L6.73627 20.881C6.42633 21.1952 5.91233 20.8311 6.1138 20.4402L10.0837 12.6914C10.1138 12.6329 10.1281 12.5678 10.1255 12.5022C10.1228 12.4367 10.1032 12.3729 10.0684 12.317C10.0337 12.2611 9.98503 12.2149 9.9271 12.183C9.86917 12.151 9.80392 12.1343 9.73759 12.1344H1.38712C1.31085 12.1344 1.23629 12.112 1.1728 12.0702C1.1093 12.0285 1.05969 11.969 1.03018 11.8995C1.00067 11.8299 0.99257 11.7533 1.0069 11.6792C1.02124 11.6051 1.05736 11.5368 1.11075 11.4829L11.4552 1.11665C11.7548 0.816451 12.2533 1.14603 12.0867 1.53564L9.12028 8.45289C9.09516 8.51154 9.08522 8.57545 9.09134 8.63885C9.09747 8.70225 9.11947 8.76314 9.15537 8.81601C9.19126 8.86889 9.23991 8.91208 9.29692 8.94169C9.35393 8.97129 9.4175 8.98638 9.48188 8.98558L17.6063 8.88594C17.683 8.88472 17.7583 8.90603 17.8227 8.94718C17.8872 8.98832 17.9378 9.04745 17.9682 9.11707C17.9986 9.1867 18.0075 9.26368 17.9936 9.33828C17.9798 9.41288 17.9439 9.48175 17.8905 9.53615L17.8892 9.53743Z",
    stroke: "white",
    strokeWidth: 1.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolUsageIcon);
export default __webpack_public_path__ + "static/media/ToolUsageIcon.820598958b62834d6dd12571927af3c1.svg";
export { ForwardRef as ReactComponent };